import { v4 } from 'uuid';

import { AxisData } from '../../spatial-classes';
import { RecordData } from '../../helpers-classes';
import { DimensionData, DimensionDataIn } from './types';

export const dimensionData = (dataIn: DimensionDataIn = null): DimensionData => {
	const rd = new RecordData<DimensionDataIn>(dataIn);
	const isVisible = rd.useNewOrDefault('isVisible', true);
	const manuallyHidden = rd.useNewOrDefault('manuallyHidden', !isVisible);

	const record: DimensionData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		sourceId: rd.useNewOrDefault('sourceId', null),
		targetId: rd.useNewOrDefault('targetId', null),
		axis: rd.useNewOrDefault<AxisData>('axis', { x: null, y: null, z: null }),
		isVisible,
		manuallyHidden,
		// legacy data flagged every rule-written dimension as manual, so only a hidden one proves the user chose it
		manualVisibility: rd.useNewOrDefault<boolean | null>('manualVisibility', manuallyHidden && !isVisible ? false : null),
		lineFactor: rd.useNewOrDefault('lineFactor', 0.5),
		labelFactor: rd.useNewOrDefault('labelFactor', 0.5),
		customAngle: rd.useNewOrDefault('customAngle', null),
		dragOffset: rd.useNewOrDefault('dragOffset', null)
	};

	return record;
};
